import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { TableAdditional } from "./Additional";
import { getTimeConfigTable } from "src/Requests/deltaHedgeBackTest";

interface IProps {
  refreshFlag: boolean;
}

const TimeConfigTable = ({ refreshFlag }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={TableAdditional}
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getTimeConfigTable}
    />
  );
};

export default TimeConfigTable;
